/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mealy_Actual_Dachshund_TrustInputs */

const fr_mealy_actual_dachshund_trust = /** @type {(inputs: Mealy_Actual_Dachshund_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement...`)
};

/**

* @param {Mealy_Actual_Dachshund_TrustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mealy_actual_dachshund_trust = /** @type {((inputs?: Mealy_Actual_Dachshund_TrustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mealy_Actual_Dachshund_TrustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mealy_actual_dachshund_trust(inputs)
});